import { useDispatch } from "react-redux";
import { headline2 } from "@shared/styles";
import DatePicker from "@shared/v2/DatePicker";
import dayjs from "@shared/dayjs";
import { containerView } from "./styles";
import { setPersonValue } from "../../reducers/contactsReducer";
import { useContactFormOptions, useContactPerson } from "../../reducers/contactsReducer/selectors";

function CustomDatesView() {
  const dispatch = useDispatch();
  const { milestones = {} } = useContactPerson();
  const { customDateOptions } = useContactFormOptions();
  return (
    <div className={containerView}>
      <div className={`tw-text-neutral-gray-75 ${headline2}`}>Custom Dates</div>
      <div className="tw-grid tw-grid-cols-2 tw-gap-[24px]">
        {customDateOptions.length > 0 &&
          customDateOptions?.map((option) => {
            let formattedDate = milestones[option.name] || null;
            if (formattedDate && dayjs.utc(formattedDate).isValid()) {
              const hasTime = formattedDate.includes(" ");
              formattedDate = dayjs
                .utc(formattedDate, hasTime ? "YYYY-MM-DD hh:mm A" : "YYYY-MM-DD")
                .format(hasTime ? "MM/DD/YYYY hh:mm A" : "MM/DD/YYYY");
            }

            return (
              <DatePicker
                key={option.name}
                inputProps={{
                  label: option.displayName,
                  placeholder: "MM/DD/YYYY",
                }}
                value={formattedDate}
                enableTimePicker={option.includeTime}
                onChange={(value) => {
                  let formattedValue = value;

                  if (value?.includes(" ")) {
                    formattedValue = dayjs.utc(value, "MM/DD/YYYY hh:mm A").format("YYYY-MM-DD hh:mm A");
                  } else if (value) {
                    formattedValue = dayjs.utc(value, "MM/DD/YYYY").format("YYYY-MM-DD");
                  }

                  dispatch(
                    setPersonValue({
                      key: `milestones.${option.name}`,
                      value: formattedValue,
                    }),
                  );
                }}
              />
            );
          })}
        {customDateOptions.length > 0 && customDateOptions?.length % 2 !== 0 && <div className="tw-flex-1" />}
        {customDateOptions.length === 0 && (
          <div className="tw-col-span-2 tw-text-neutral-gray-50">
            No custom dates have been created yet. These can be added from the{" "}
            <a
              href="https://app.brivity.com/new_milestones"
              target="_blank"
              rel="noreferrer"
              className="tw-text-theme-text-button-color"
            >
              Dates settings
            </a>{" "}
            page.
          </div>
        )}
      </div>
    </div>
  );
}

export default CustomDatesView;
